<div *transloco="let t">
    <h1>{{t('notification_page_title')}}</h1>
</div>
